var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"applebox"},[_c('span',{staticClass:"apple"},[_vm._v(" Accedi con Apple ")]),_c('vue-apple-login',{attrs:{"radius":20,"border":true,"type":"sign in","className":"vue-apple-login btn","onSuccess":_vm.appleSuccess,"onFailure":_vm.appleFail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }